module.exports = __webpack_public_path__ + "img/zproject-3d-model.b5222d20.jpg";